import _extends from "@babel/runtime-corejs3/helpers/extends";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/splice";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/slice";
import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find-index";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import React, { useContext, useRef, useState, useEffect, useLayoutEffect, useCallback } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import { Input, Icon, Tabs, Empty, Spin, Checkbox } from '../index';
import usePopper from '../_utils/usePopper';

var InternalBaseData = function InternalBaseData(props, ref) {
  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls,
      userDefaultProps = _useContext.compDefaultProps,
      getLangMsg = _useContext.locale.getLangMsg;

  var advancedSelectortProps = getCompProps('BaseData', userDefaultProps, props);
  var customPrefixcls = advancedSelectortProps.prefixCls,
      className = advancedSelectortProps.className,
      mode = advancedSelectortProps.mode,
      disabled = advancedSelectortProps.disabled,
      _advancedSelectortPro = advancedSelectortProps.delimiter,
      delimiter = _advancedSelectortPro === void 0 ? '，' : _advancedSelectortPro,
      _advancedSelectortPro2 = advancedSelectortProps.placeholder,
      placeholder = _advancedSelectortPro2 === void 0 ? getLangMsg('global', 'selectholder') : _advancedSelectortPro2,
      showDetailIcon = advancedSelectortProps.showDetailIcon,
      showFrequent = advancedSelectortProps.showFrequent,
      showCollectIcon = advancedSelectortProps.showCollectIcon,
      columns = advancedSelectortProps.columns,
      _advancedSelectortPro3 = advancedSelectortProps.options,
      options = _advancedSelectortPro3 === void 0 ? [] : _advancedSelectortPro3,
      value = advancedSelectortProps.value,
      optionLabelProp = advancedSelectortProps.optionLabelProp,
      size = advancedSelectortProps.size,
      style = advancedSelectortProps.style,
      dropdownFooterRender = advancedSelectortProps.dropdownFooterRender,
      _advancedSelectortPro4 = advancedSelectortProps.collectList,
      collectList = _advancedSelectortPro4 === void 0 ? [] : _advancedSelectortPro4,
      _advancedSelectortPro5 = advancedSelectortProps.historyList,
      historyList = _advancedSelectortPro5 === void 0 ? [] : _advancedSelectortPro5,
      loading = advancedSelectortProps.loading,
      searchField = advancedSelectortProps.searchField,
      dropdownStyle = advancedSelectortProps.dropdownStyle,
      onChange = advancedSelectortProps.onChange,
      onSearch = advancedSelectortProps.onSearch,
      onSelect = advancedSelectortProps.onSelect,
      onShowDetail = advancedSelectortProps.onShowDetail,
      onCollect = advancedSelectortProps.onCollect,
      onShowMore = advancedSelectortProps.onShowMore,
      onVisibleChange = advancedSelectortProps.onVisibleChange;
  var isMultiple = mode === 'multiple'; // 是否多选

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      seletedOptions = _useState2[0],
      setSeletedOptions = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      inputValue = _useState4[0],
      setInputValue = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      indxPosList = _useState6[0],
      setIndxPosList = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      showTotal = _useState8[0],
      setShowTotal = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      isFocused = _useState10[0],
      setFocused = _useState10[1];

  var _useState11 = useState(!!props.visible),
      _useState12 = _slicedToArray(_useState11, 2),
      optionShow = _useState12[0],
      setOptionShow = _useState12[1];

  var innerRef = useRef();
  var advancedSelectorRef = ref || innerRef;
  var inputRef = useRef();
  var searchInfo = useRef({
    previousInputValue: '',
    searchIndex: 0,
    editOptions: [],
    selectionStart: 0,
    previousEditValue: '',
    deleteEndIndx: 0
  });
  var advancedSelectorfixCls = getPrefixCls(prefixCls, 'baseData', customPrefixcls); // class

  var advancedSelectorCls = classNames(advancedSelectorfixCls, className, _defineProperty({}, "".concat(advancedSelectorfixCls, "-disabled"), disabled)); // 多选模式下 维护新增选中的下标

  useEffect(function () {
    searchInfo.current.searchIndex = seletedOptions.length;
    searchInfo.current.editOptions = seletedOptions;
  }, [seletedOptions]); // 记录每个选项的开始与结束下标

  var setValIndxPosition = useCallback(function () {
    var arr = [];
    inputValue.split(delimiter).reduce(function (pre, next) {
      arr.push({
        start: pre,
        end: pre + next.length
      });
      return pre + next.length + 1;
    }, 0);
    return arr;
  }, [delimiter, inputValue]);
  useEffect(function () {
    var list = setValIndxPosition();
    setIndxPosList(list);
  }, [setValIndxPosition]);
  useEffect(function () {
    var seletedItems = []; // 多选

    if (isMultiple && Array.isArray(value)) {
      seletedItems = value;
    } // 单选


    if (!isMultiple && value) {
      seletedItems = [value];
    }

    setSeletedOptions(seletedItems);
    searchInfo.current.editOptions = _toConsumableArray(seletedItems);
  }, [value, isMultiple]);
  useEffect(function () {
    var _a;

    if (!searchInfo.current.previousEditValue) return;
    var posList = setValIndxPosition();
    var preValueArr = getStrToArr(searchInfo.current.previousEditValue, delimiter);
    var valueArr = getStrToArr(inputValue, delimiter);
    var selectionStart = ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.selectionStart) || 0;
    var index = findSelectionIndex(selectionStart, posList);
    searchInfo.current.searchIndex = index; // 新增一个

    var list = _toConsumableArray(searchInfo.current.editOptions || []);

    if (valueArr.length - preValueArr.length === 1) {
      searchInfo.current.deleteEndIndx = index;

      _spliceInstanceProperty(list).call(list, index, 0, null);
    }

    if (valueArr.length < preValueArr.length) {
      var val = searchInfo.current.previousEditValue;
      /**
       * selectionStart 被删除的字符串开始下标
       * deleteEndIndx 被删除的字符串结束下标
       * 多选时，判断删除的字符包含了几个已选项
       * 单选时，判断selectionStart与deleteEndIndx相等（都为0），则表示选项被删除
       */

      var deleteEndIndx = isMultiple ? val.length - inputValue.length + selectionStart : 0;

      var _findDeleteInterval = findDeleteInterval(selectionStart, deleteEndIndx, indxPosList),
          start = _findDeleteInterval.start,
          end = _findDeleteInterval.end;

      list === null || list === void 0 ? void 0 : _spliceInstanceProperty(list).call(list, start, end - start + 1);
    }

    searchInfo.current.editOptions = list;
    searchInfo.current.previousEditValue = inputValue; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delimiter, inputValue, isMultiple, setValIndxPosition]);

  var getStrToArr = function getStrToArr() {
    var _context;

    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var delimiter = arguments.length > 1 ? arguments[1] : undefined;
    return _filterInstanceProperty(_context = str.split(delimiter)).call(_context, function (item) {
      return item;
    });
  }; // 当选中项文字超出输入框时，显示共多少项


  useLayoutEffect(function () {
    if (!inputRef.current) return;

    if (inputRef.current.scrollWidth - inputRef.current.offsetWidth > 0) {
      setShowTotal(true);
    } else {
      setShowTotal(false);
    }
  }, [inputRef, inputValue]); // 通过选中项显示input文字， optionLabelProp为回填到选择框的属性

  var setValueBySeleted = useCallback(function () {
    var _context4;

    var defaultInputValue = seletedOptions.reduce(function (pre, next, index, arr) {
      var _context2, _context3;

      return _concatInstanceProperty(_context2 = _concatInstanceProperty(_context3 = "".concat(pre)).call(_context3, next[optionLabelProp])).call(_context2, index !== arr.length - 1 ? delimiter : '');
    }, '');
    searchInfo.current.previousInputValue = defaultInputValue;
    setInputValue(defaultInputValue);
    searchInfo.current.previousEditValue = _concatInstanceProperty(_context4 = "".concat(defaultInputValue)).call(_context4, delimiter);
  }, [delimiter, optionLabelProp, seletedOptions]);
  useEffect(function () {
    setValueBySeleted();
  }, [setValueBySeleted]);

  var changeInputText = function changeInputText(e) {
    setOptionShow(true);
    var textValue = e.target.value;
    var val = textValue;

    if (isMultiple && inputRef.current && textValue && textValue.length > inputValue.length) {
      var selectionStart = inputRef.current.selectionStart || 0; // selectionStart: 光标前面有几个字符

      searchInfo.current.selectionStart = selectionStart;
      var isInHead = selectionStart === 1 && textValue[1] !== delimiter && textValue.length !== 1; // 在首部添加

      var isInMid = selectionStart !== textValue.length && textValue[selectionStart - 2] === delimiter && textValue[selectionStart] !== delimiter;

      if (isInHead || isInMid) {
        inputRef.current.value = val = textValue.substring(0, selectionStart) + delimiter + textValue.substring(selectionStart, textValue.length);
        setCursorPosition(inputRef.current, selectionStart);
      }
    }

    setInputValue(val);
    handleChange(val);
  };

  var handleChange = function handleChange(val) {
    var str = getQueryStr(val);
    searchInfo.current.searchValue = str;
    onSearch === null || onSearch === void 0 ? void 0 : onSearch(str);
  };

  var getQueryStr = function getQueryStr(queryStr) {
    if (!isMultiple) {
      return queryStr;
    }

    if (inputRef.current && queryStr) {
      if (queryStr.indexOf(delimiter) < 0) {
        // 只有一条记录
        return queryStr;
      }

      var selectionStart = inputRef.current.selectionStart || 0;
      var startIndex = _sliceInstanceProperty(queryStr).call(queryStr, 0, selectionStart).lastIndexOf(delimiter) + 1; // 光标前面最近分隔符index

      var endIndex = _sliceInstanceProperty(queryStr).call(queryStr, selectionStart).indexOf(delimiter);

      endIndex = endIndex === -1 ? queryStr.length : selectionStart + endIndex; // 光标后面最近分隔符index

      queryStr = _sliceInstanceProperty(queryStr).call(queryStr, startIndex, endIndex);
      return queryStr;
    }

    return queryStr;
  };

  var handleFocus = function handleFocus() {
    var _context5;

    if (disabled) return;
    setFocused(true);
    isMultiple && seletedOptions.length && setInputValue(_concatInstanceProperty(_context5 = "".concat(inputValue)).call(_context5, delimiter));
  };

  var handleBlur = function handleBlur() {
    var _context6, _context7;

    if (disabled) return;
    setFocused(false);
    setInputValue(searchInfo.current.previousInputValue);
    searchInfo.current.previousEditValue = _concatInstanceProperty(_context6 = "".concat(searchInfo.current.previousInputValue)).call(_context6, delimiter); // 多选失去焦点时，通过editOptions去改写选中项

    var list = _filterInstanceProperty(_context7 = searchInfo.current.editOptions || []).call(_context7, function (item) {
      return item;
    }) || [];

    if (_JSON$stringify(list) !== _JSON$stringify(seletedOptions)) {
      var _context8;

      onChange === null || onChange === void 0 ? void 0 : onChange(_mapInstanceProperty(_context8 = _filterInstanceProperty(list).call(list, function (item) {
        return item;
      })).call(_context8, function (v) {
        return v.value;
      }), _filterInstanceProperty(list).call(list, function (item) {
        return item;
      }));
    }

    if (value !== undefined) {
      return;
    }

    setSeletedOptions(list);
  };

  var showInputTotal = function showInputTotal() {
    if (disabled) return;

    if (inputRef.current) {
      var scrollToWidth = inputRef.current.scrollWidth - inputRef.current.offsetWidth;
      inputRef.current.scrollLeft = scrollToWidth;
      setTimeout(function () {
        setCursorPosition(inputRef.current, inputValue.length + 1);
      }, 0);
    }
  };

  var handleShowDetail = function handleShowDetail(e) {
    e.stopPropagation();
    onShowDetail === null || onShowDetail === void 0 ? void 0 : onShowDetail(seletedOptions);
  };

  var handleShowMore = function handleShowMore(e) {
    e.stopPropagation();
    onShowMore === null || onShowMore === void 0 ? void 0 : onShowMore();
  }; // 设置光标位置


  var setCursorPosition = function setCursorPosition(element, prePosition) {
    if (element.setSelectionRange) {
      // Chrome Firefox
      element.focus();
      window.setTimeout(element.setSelectionRange(prePosition, prePosition), 0);
    } else if (element.createTextRange) {
      // 兼容IE
      var range = element.createTextRange;
      range.collapse(true);
      range.moveEnd('character', prePosition);
      range.moveStart('character', prePosition);
      range.select();
    }
  }; // 双击选中当前项


  var handleDoubleClick = function handleDoubleClick() {
    var _a, _b;

    var _findDbClickSelectedP = findDbClickSelectedPos(((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.selectionStart) || 0, ((_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.selectionEnd) || 0),
        start = _findDbClickSelectedP.start,
        end = _findDbClickSelectedP.end;

    handleSeletedText(inputRef.current, start, end);
  };

  var findDbClickSelectedPos = function findDbClickSelectedPos(selectionStart, selectionEnd) {
    for (var index = 0; index < indxPosList.length; index++) {
      var item = indxPosList[index];

      if (item.start <= selectionStart && item.end >= selectionEnd) {
        return item;
      }
    }

    return {};
  }; // 多选，找到光标停留的当前项的下标


  var findSelectionIndex = function findSelectionIndex(selectionStart, posList) {
    var indx = 0;

    for (var index = 0; index < posList.length; index++) {
      var v = posList[index];

      if (v.start <= selectionStart && v.end >= selectionStart) {
        indx = index;
      }
    }

    return indx;
  };
  /**
   * 找出删除项的下标
   *
   * @param start 删除时文字光标的起始位置
   * @param end 删除时文字光标的终止位置
   * @param posList 每个选中项的下标区间
   */


  var findDeleteInterval = function findDeleteInterval(start, end, posList) {
    var delIndex = {
      start: null,
      end: null
    };

    for (var index = 0; index < posList.length; index++) {
      var v = posList[index];
      if (v.start >= start && delIndex.start === null) delIndex.start = index;
      if (v.end <= end) delIndex.end = index;
    }

    return delIndex;
  };

  var handleSeletedText = function handleSeletedText(element, start, end) {
    element.setSelectionRange(start, end);
  };

  var handleSelect = function handleSelect(item) {
    var _context13;

    searchInfo.current.searchValue = undefined;

    if (_findIndexInstanceProperty(seletedOptions).call(seletedOptions, function (v) {
      return v.value === item.value;
    }) !== -1) {
      var _context9;

      var _list = _filterInstanceProperty(seletedOptions).call(seletedOptions, function (v) {
        return v.value !== item.value;
      }); // 取消选中(非受控状态下)


      isMultiple && value === undefined && setSeletedOptions(_list);
      onChange === null || onChange === void 0 ? void 0 : onChange(_mapInstanceProperty(_context9 = _filterInstanceProperty(_list).call(_list, function (item) {
        return item;
      })).call(_context9, function (v) {
        return v.value;
      }), _filterInstanceProperty(_list).call(_list, function (item) {
        return item;
      }));
      return;
    }

    var list = _toConsumableArray(searchInfo.current.editOptions || []);

    list === null || list === void 0 ? void 0 : _spliceInstanceProperty(list).call(list, searchInfo.current.searchIndex || 0, 1, item);

    if (isMultiple) {
      var _context10, _context11, _context12;

      onChange === null || onChange === void 0 ? void 0 : onChange(_mapInstanceProperty(_context10 = _filterInstanceProperty(_context11 = list || []).call(_context11, function (item) {
        return item;
      })).call(_context10, function (v) {
        return v.value;
      }), _filterInstanceProperty(_context12 = list || []).call(_context12, function (item) {
        return item;
      }));
    } else {
      onChange === null || onChange === void 0 ? void 0 : onChange(item.value, item);
    }

    onSelect === null || onSelect === void 0 ? void 0 : onSelect(item.value, item);

    if (value !== undefined) {
      return;
    }

    searchInfo.current.editOptions = list;
    setSeletedOptions(_filterInstanceProperty(_context13 = list || []).call(_context13, function (item) {
      return item;
    }));
  };

  var handleSelectAll = function handleSelectAll(e) {
    var list = e.target.checked ? options : [];
    onChange(_mapInstanceProperty(list).call(list, function (item) {
      return item.value;
    }), list);

    if (value !== undefined) {
      return;
    }

    setSeletedOptions(list);
  };

  var handleCollect = useCallback(function (item, flag) {
    onCollect === null || onCollect === void 0 ? void 0 : onCollect(flag, item);
  }, [onCollect]);
  var isShowDetailBtn = showDetailIcon && !isMultiple && !isFocused;

  var renderAdvancedSelector = function renderAdvancedSelector() {
    return /*#__PURE__*/React.createElement("div", {
      className: advancedSelectorCls,
      ref: advancedSelectorRef,
      style: style
    }, /*#__PURE__*/React.createElement(Input, {
      ref: inputRef,
      borderType: "none",
      disabled: disabled,
      onChange: changeInputText,
      placeholder: placeholder,
      value: inputValue,
      onDoubleClick: handleDoubleClick,
      onFocus: handleFocus,
      onBlur: handleBlur
    }), showTotal && !isFocused && isMultiple && /*#__PURE__*/React.createElement("span", {
      className: "".concat(advancedSelectorfixCls, "-total"),
      onClick: showInputTotal
    }, "\u5171".concat(seletedOptions.length, "\u9879")), isShowDetailBtn && !disabled && /*#__PURE__*/React.createElement("span", {
      className: "".concat(advancedSelectorfixCls, "-detail"),
      onClick: handleShowDetail
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "material"
    })), !disabled && /*#__PURE__*/React.createElement("span", {
      className: "".concat(advancedSelectorfixCls, "-suffix"),
      onClick: handleShowMore
    }, /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })));
  }; // 渲染下拉列表框


  var renderContent = function renderContent() {
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(advancedSelectorfixCls, "-dropdown")
    }, searchInfo.current.searchValue ? renderDropdownContent(options, columns, true, true) : renderHistoryContent());
  };
  /**
   * 判断Checkbox半选状态
   *
   * @param {string[]} value 选中项数组
   * @returns {boolean}
   */


  var getIndeterminate = useCallback(function (value) {
    return value.length > 0 && value.length < options.length;
  }, [options]);

  var getChecked = function getChecked(value) {
    return options.length && value.length === options.length;
  };
  /**
   * 渲染下拉列表
   *
   * @param {IOptionsProps} data 下拉列表的数据
   * @param {IColumnsProps} myColumns 下拉列表的展示列
   * @param {boolean} showFooter 是否显示下拉框footer
   * @param {boolean} showCheckbox 是否显示多选框
   * @returns {React.ReactNode}
   */


  var renderDropdownContent = function renderDropdownContent(data, myColumns) {
    var _context14;

    var showFooter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var showCheckbox = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var dropDownColumns = myColumns && Array.isArray(myColumns) ? myColumns : data && Array.isArray(data) && data.length ? _mapInstanceProperty(_context14 = _Object$keys(data[0])).call(_context14, function (v) {
      return {
        key: v
      };
    }) : [];
    var indeterminate = getIndeterminate(seletedOptions);
    var checked = getChecked(seletedOptions);
    return /*#__PURE__*/React.createElement(React.Fragment, null, myColumns && Array.isArray(myColumns) && /*#__PURE__*/React.createElement("div", {
      className: "".concat(advancedSelectorfixCls, "-dropdown-columns")
    }, _mapInstanceProperty(dropDownColumns).call(dropDownColumns, function (item, index) {
      return /*#__PURE__*/React.createElement("span", {
        key: item.key,
        className: "".concat(advancedSelectorfixCls, "-dropdown-columns-item"),
        title: item.title
      }, isMultiple && index === 0 && showCheckbox && /*#__PURE__*/React.createElement(Checkbox, {
        style: {
          marginRight: 5
        },
        checked: checked,
        indeterminate: indeterminate,
        onChange: handleSelectAll
      }), item.title);
    })), loading ? /*#__PURE__*/React.createElement("div", {
      className: "".concat(advancedSelectorfixCls, "-dropdown-loading")
    }, /*#__PURE__*/React.createElement(Spin, null)) : data.length ? renderOptionsContent(data, dropDownColumns, showCheckbox) : renderNotContent(), showFooter && dropdownFooterRender && /*#__PURE__*/React.createElement("div", {
      className: "".concat(advancedSelectorfixCls, "-dropdown-footer")
    }, dropdownFooterRender));
  };
  /**
   * 渲染收藏图标
   *
   * @param {IOptionsProps} item
   * @returns {React.ReactNode}
   */


  var renderCollect = useCallback(function (item) {
    return /*#__PURE__*/React.createElement("span", {
      className: "".concat(advancedSelectorfixCls, "-dropdown-options-item-collect"),
      onMouseDown: function onMouseDown(e) {
        return e.stopPropagation();
      }
    }, _findIndexInstanceProperty(collectList).call(collectList, function (v) {
      return v.value === item.value;
    }) === -1 ? /*#__PURE__*/React.createElement(Icon, {
      className: "".concat(advancedSelectorfixCls, "-dropdown-options-item-collect-not-icon"),
      type: "collect",
      onClick: function onClick() {
        return handleCollect(item, true);
      }
    }) : /*#__PURE__*/React.createElement(Icon, {
      className: "".concat(advancedSelectorfixCls, "-dropdown-options-item-collect-icon"),
      type: "star",
      onClick: function onClick() {
        return handleCollect(item, false);
      },
      style: {
        visibility: 'visible'
      }
    }));
  }, [advancedSelectorfixCls, collectList, handleCollect]);

  var renderSearchValue = function renderSearchValue(item, column) {
    return searchField === 'all' || searchField === column.key ? findSearchValue(item[column.key]) : item[column.key];
  };
  /**
   * 渲染下拉项
   *
   * @param {IOptionsProps} data 下拉列表的数据
   * @param {IColumnsProps} myColumns 下拉列表的展示列
   * @param {boolean} showCheckbox 是否显示多选框
   * @returns {React.ReactNode}
   */


  var renderOptionsContent = function renderOptionsContent(data, myColumns) {
    var showCheckbox = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return /*#__PURE__*/React.createElement(React.Fragment, null, _mapInstanceProperty(data).call(data, function (item, index) {
      if (index + 1 > size) {
        return null;
      }

      return /*#__PURE__*/React.createElement("div", {
        key: item.value,
        className: classNames("".concat(advancedSelectorfixCls, "-dropdown-options"), {
          selected: seletedOptions.some(function (v) {
            return v.value === item.value;
          })
        }),
        onMouseDown: function onMouseDown() {
          return handleSelect(item);
        }
      }, _mapInstanceProperty(myColumns).call(myColumns, function (column, index) {
        return /*#__PURE__*/React.createElement("span", {
          key: column.key,
          className: "".concat(advancedSelectorfixCls, "-dropdown-options-item"),
          title: item[column.key]
        }, isMultiple && showCheckbox && index === 0 && /*#__PURE__*/React.createElement(Checkbox, {
          style: {
            marginRight: 5
          },
          value: item.value,
          checked: seletedOptions.some(function (v) {
            return v.value === item.value;
          })
        }), renderSearchValue(item, column), showCollectIcon && myColumns.length - 1 === index && renderCollect(item));
      }));
    }));
  };
  /**
   * 标注出搜索的文字
   *
   * @param {string} title 搜索的文字
   * @returns {React.ReactNode}
   */


  var findSearchValue = function findSearchValue(title) {
    var _searchInfo$current$s = searchInfo.current.searchValue,
        searchValue = _searchInfo$current$s === void 0 ? '' : _searchInfo$current$s;
    var index = title.indexOf(searchValue);
    var beforeStr = title.substr(0, index);
    var afterStr = title.substr(index + searchValue.length);
    var content = index > -1 ? /*#__PURE__*/React.createElement("span", null, beforeStr, /*#__PURE__*/React.createElement("span", {
      className: "".concat(advancedSelectorfixCls, "-dropdown-options-item-search")
    }, searchValue), afterStr) : /*#__PURE__*/React.createElement("span", null, title);
    return content;
  };

  var renderHistoryContent = function renderHistoryContent() {
    if (!showFrequent) {
      return null;
    }

    return /*#__PURE__*/React.createElement(Tabs, {
      defaultActiveKey: "history"
    }, /*#__PURE__*/React.createElement(Tabs.TabPane, {
      key: "history",
      tab: "\u5386\u53F2\u8BB0\u5F55"
    }, renderDropdownContent(historyList, columns)), /*#__PURE__*/React.createElement(Tabs.TabPane, {
      key: "collect",
      tab: "\u6211\u7684\u6536\u85CF"
    }, renderDropdownContent(collectList, columns)));
  };

  var renderNotContent = useCallback(function () {
    return /*#__PURE__*/React.createElement("div", {
      className: "".concat(advancedSelectorfixCls, "-dropdown-empty")
    }, /*#__PURE__*/React.createElement(Empty, null));
  }, [advancedSelectorfixCls]);

  var catchStyle = function catchStyle() {
    if (advancedSelectorRef === null || advancedSelectorRef === void 0 ? void 0 : advancedSelectorRef.current) {
      return {
        width: (dropdownStyle === null || dropdownStyle === void 0 ? void 0 : dropdownStyle.width) || 330,
        zIndex: 1050
      };
    }
  };

  var handleVisibleChange = function handleVisibleChange(visible) {
    onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(visible);
    if (props.visible !== undefined) return;

    if (visible) {
      isFocused && setOptionShow(visible);
      return;
    }

    setOptionShow(visible);
  };

  var popperProps = _extends(_extends({
    popperStyle: catchStyle(),
    placement: 'bottomLeft'
  }, advancedSelectortProps), {
    defaultVisible: optionShow,
    visible: optionShow,
    prefixCls: "".concat(advancedSelectorfixCls, "-dropdown-wrapper"),
    onVisibleChange: handleVisibleChange
  });

  return usePopper(renderAdvancedSelector(), renderContent(), popperProps);
};

var BaseData = /*#__PURE__*/React.forwardRef(InternalBaseData);
BaseData.displayName = 'BaseData';
export default BaseData;